// ============================================================
// CODiii Site Infrastructure Element Types — Canada
// Structure: ['key', 'Display Title', 'Short description', 'code', 'family']
// family: linear | area | point | network
// Keys are shared with infrastructureElementTypes_US.js
// ============================================================

export const INFRA_ELEMENT_TYPES_CA = [
  // Transportation & access
  ['road', 'Road', 'Municipal road, collector, or arterial corridor', 'road', 'linear'],
  ['driveway', 'Driveway / Access', 'Site access drive and apron', 'drive', 'linear'],
  ['parking-lot', 'Parking Lot', 'Surface or structured parking area', 'park', 'area'],
  ['sidewalk', 'Sidewalk / Pedestrian Path', 'Pedestrian walkway or multi-use path', 'walk', 'linear'],
  ['bicycle-facility', 'Bicycle Facility', 'Bike lane, path, or rack area', 'bike', 'linear'],
  ['bridge', 'Bridge', 'Highway, pedestrian, or rail bridge', 'br', 'linear'],

  // Stormwater & drainage
  ['stormwater-pond', 'Stormwater Management Pond', 'Detention or retention pond (SWM)', 'swm', 'area'],
  ['stormwater-outfall', 'Stormwater Outfall', 'Discharge point to receiving water', 'outfall', 'point'],
  ['catch-basin', 'Catch Basin / Inlet', 'Storm drain inlet structure', 'inlet', 'point'],
  ['storm-sewer', 'Storm Sewer', 'Storm drainage pipe network', 'stm', 'network'],
  ['culvert', 'Culvert', 'Culvert crossing under road or embankment', 'culv', 'linear'],

  // Water & wastewater
  ['watermain', 'Watermain', 'Municipal water distribution main', 'wm', 'network'],
  ['sanitary-sewer', 'Sanitary Sewer', 'Sanitary sewer gravity or force main', 'san', 'network'],
  ['force-main', 'Force Main', 'Pressurized sanitary force main', 'force', 'network'],
  ['hydrant', 'Fire Hydrant', 'Municipal fire hydrant assembly', 'hyd', 'point'],

  // Site & earthworks
  ['grading-earthworks', 'Grading / Earthworks', 'Cut, fill, and site grading works', 'grade', 'area'],
  ['retaining-wall', 'Retaining Wall', 'Retaining or structural earth support', 'wall', 'linear'],
  ['right-of-way', 'Right-of-Way (ROW)', 'Dedicated corridor or easement', 'row', 'linear'],

  // Utilities
  ['electrical-ductbank', 'Electrical Duct Bank', 'Underground electrical duct bank', 'elec', 'network'],
  ['gas-main', 'Gas Main', 'Natural gas distribution main', 'gas', 'network'],
  ['telecommunications', 'Telecommunications', 'Fiber, conduit, or telecom trench', 'tel', 'network'],

  // Other
  ['landscaping', 'Landscaping', 'Soft landscaping, planting, or turf', 'land', 'area'],
  ['fencing', 'Fencing', 'Site perimeter or security fencing', 'fence', 'linear'],
];
